// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationPopup_container__1QZWa","title":"ConfirmationPopup_title__WNjAX","body":"ConfirmationPopup_body__+xqoc"};